import { Footer } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/timesheetViewModalFooter.styles';
import CloseTimesheetFooterButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/CloseTimesheetFooterButton';

type Props = {
  onClose: VoidFunction;
};
const TimesheetViewModalEmployeeFooter = ({ onClose }: Props) => (
  <Footer>
    <CloseTimesheetFooterButton onClose={onClose} />
  </Footer>
);

export default TimesheetViewModalEmployeeFooter;
